import { defineMessages } from 'react-intl';

export const labelMessages = defineMessages({
  statusLabel: {
    defaultMessage: 'Status',
    description: 'status grid column text'
  },
  documentIdLabel: {
    defaultMessage: 'Payment No.',
    description: 'documentId grid column text'
  },
  payableIdLabel: {
    defaultMessage: 'Payable ID',
    description: 'transactionId grid column text'
  },
  cardNoLabel: {
    defaultMessage: 'Card No.',
    description: 'card no. grid column text'
  },
  vendorNoLabel: {
    defaultMessage: 'Vendor No.',
    description: 'vendor id grid column text'
  },
  vendorNameLabel: {
    defaultMessage: 'Vendor Name',
    description: 'vendor name grid column text'
  },
  paymentAmountLabel: {
    defaultMessage: 'Payment ($)',
    description: 'amount grid column text'
  },
  settledAmountLabel: {
    defaultMessage: 'Settled ($)',
    description: 'settled amount grid column text'
  },
  paymentDateLabel: {
    defaultMessage: 'Payment Date',
    description: 'payment date grid column text'
  },
  transactionDateLabel: {
    defaultMessage: 'Transaction Date',
    description: 'transaction date grid column text'
  },
  settledDateLabel: {
    defaultMessage: 'Settled Date',
    description: 'settled date grid column text'
  },
  voidLabel: {
    defaultMessage: 'Void',
    description: 'void grid column text'
  },
  documentIdInDialogLabel: {
    defaultMessage: 'Payment',
    description: 'Payment label in void credit card dialog'
  },
  paymentDateInDialogLabel: {
    defaultMessage: 'Payment Date',
    description: 'Payment Date label in void credit card dialog'
  },
  amountInDialogLabel: {
    defaultMessage: 'Amount',
    description: 'Amount label in void credit card dialog'
  },
  voidPaymentDialogTitle: {
    defaultMessage: 'Void Credit Card Payment?',
    description: 'Title for void credit card payment dialog'
  },
  reconciliationTableHeaderTitle: {
    defaultMessage: 'Reconciliation Report',
    description: 'Reconciliation Table HeaderTitle'
  },
  reconciliationReportDialogTitle: {
    defaultMessage: 'Export/Archive - Reconcile Credit Card',
    description: 'Title for export/archive dialog'
  },
  inputColumns: {
    defaultMessage: 'Columns',
    description: 'Columns for column filter'
  },
  inputSelect: {
    defaultMessage: 'Select',
    description: 'Select label for column filter'
  },
  inputSelected: {
    defaultMessage: 'Selected',
    description: 'Selected label for selected columns from filter'
  },
  inputAllSelected: {
    defaultMessage: 'All Selected',
    description: 'All Selected label for all columns selected'
  },
  errorMessage: {
    description: 'Payment status update end point failure response',
    defaultMessage: 'Failed to update payment status'
  },
  voidButton: {
    defaultMessage: 'Void',
    description: 'Void button text'
  },
  paymentMessage: {
    defaultMessage: 'This payment will be cancelled.',
    description: ' Description that is displayed as a dialog content'
  },
  voidPaymentSuccessfulMessage: {
    defaultMessage: 'successfully voided',
    description: 'Description displayed after successful voiding a payment'
  },
  voidPaymentErrorMessage: {
    defaultMessage: 'Error while voiding payment',
    description: 'Description displayed after error voiding a payment'
  },
  refetchErrorMessage: {
    defaultMessage: 'Error while fetching reconciliation report',
    description:
      'Description displayed after error fetching reconciliation report'
  },
  payablesSelected: {
    defaultMessage: 'Payables Selected',
    description: 'Message for number of paybles selected (plural)'
  },
  payableSelected: {
    defaultMessage: 'Payable Selected',
    description: 'Message for number of paybles selected (singular)'
  },
  dismissButton: {
    description: 'dismiss button label',
    defaultMessage: 'Dismiss'
  },
  retryButton: {
    description: 'retry button label',
    defaultMessage: 'Retry'
  },
  datePickerChipLabel: {
    description: 'Label for date picker chip',
    defaultMessage: 'Settled On or Before'
  }
});

export const errorMessages = defineMessages({
  saveButton: {
    defaultMessage: 'First, select which payables to reconcile.',
    description:
      'Error message to display when save button is clicked after no selection is made'
  },
  lessThanTenFailed: {
    defaultMessage:
      'The following records could not be updated. Please try again.',
    description:
      'Error message to display when there is less than or equal to 10 failures in reconcile/settled records'
  },
  greaterThanTenFailed: {
    defaultMessage: '{count} records could not be updated. Please try again.',
    description:
      'Error message to display when there is greater than 10 failures in reconcile/settled records'
  },
  allRecordsFailed: {
    defaultMessage: 'Records cannot be updated at this time. Please try again.',
    description: 'Error message to display when all the records fail'
  }
});
